import axios from 'axios';
import { io } from 'socket.io-client';

const API_BASE_URL = '/api';
const socket = io();

export default {
  async getCountries() {
    try {
      const response = await axios.get(`${API_BASE_URL}/countries`);
      const sortedCountries = response.data.sort((a, b) => {
        if (a.usage_count === 0 && b.usage_count === 0) {
          return a.name.localeCompare(b.name);
        }
        if (a.usage_count === 0) return 1;
        if (b.usage_count === 0) return -1;
        return b.usage_count - a.usage_count;
      });

      return sortedCountries;
    } catch (error) {
      console.error('Erreur lors de la récupération des pays:', error);
      return [];
    }
  },


  async getPosts() {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des pays:', error);
      return [];
    }
  },

  async getLastMe() {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/me`);
      return response?.data || null;
    } catch (error) {
      return [];
    }
  },
  async getThemes() {
    try {
      const response = await axios.get(`${API_BASE_URL}/themes`);

      const sortedThemes = response.data.sort((a, b) => {
        if (a.usage_count === 0 && b.usage_count === 0) {
          return a.name.localeCompare(b.name);
        }
        if (a.usage_count === 0) return 1;
        if (b.usage_count === 0) return -1;
        return b.usage_count - a.usage_count;
      });

      return sortedThemes;
    } catch (error) {
      console.error('Erreur lors de la récupération des thèmes:', error);
      return [];
    }
  },

  async submitPost(postData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/posts`, postData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la soumission du post:', error);
      throw error;
    }
  },

  async getPostsByQuery(countryId, themeId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/posts/by-query`, {
        params: {
          countryId: countryId,
          themeId: themeId
        }
      });
      return response?.data?.posts || [];
    } catch (error) {
      console.error("Erreur lors de la récupération des posts:", error);
      throw error;
    }
  }, 

  // Traduire du texte dans la langue 
  async  translateText(text, targetLanguage) {
    const response = await fetch(`https://translation.googleapis.com/language/translate/v2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer YOUR_GOOGLE_API_KEY',
      },
      body: JSON.stringify({
        q: text,
        target: targetLanguage,
      }),
    });
  
    const data = await response.json();
    return data.data.translations[0].translatedText;
  },

  listenForNewPost() {
    return new Promise((resolve, reject) => {
      if (socket) {
        socket.on("newPost", (newPost) => {
          resolve(newPost);
        });
      } else {
        reject("La connexion WebSocket n'est pas encore établie");
      }
    });
  }
};
